import React, { useEffect, useState } from "react";
import {
  Route,
  BrowserRouter as Router,
  Routes as Switch,
  Navigate,
} from "react-router-dom";
import LoginPage from "./Pages/LoginPage";
import DashboardPage from "./Pages/Dashboard";
import SuperProvider from "./Context/SuperProvider";
import ForgotPassword from "./Pages/ForgotPassword";
import ErrorPage from "./Pages/ErrorPage";
import DepartmentsPage from "./Components/Departments/DepartmentsPage";
import SuppliersPage from "./Components/Suppliers/SuppliersPage";
import CreateRequisition from "./Components/Requisition/CreateRequisition";
import ViewRequisitions from "./Components/Requisition/ViewRequisitions";
import PendingRequisitionApprovals from "./Components/RequisitionApprovals/PendingRequisitionApprovals";
import UserRequisitionApprovals from "./Components/RequisitionApprovals/UserRequisitionApprovals";
import CreatePurchaseOrder from "./Components/PurchaseOrders/CreatePurchaseOrder";
import ViewPurchaseOrders from "./Components/PurchaseOrders/ViewPurchaseOrders";
import CreateDeliveryNote from "./Components/Delivery_notes/CreateDeliveryNote";
import ViewDeliveryNotes from "./Components/Delivery_notes/ViewDeliveryNotes";
import CreateSupplierInvoice from "./Components/SupplierIvoices/CreateSupplierInvoice";
import ViewSupplierInvoices from "./Components/SupplierIvoices/ViewSupplierInvoices";
import CreateSupplierPayments from "./Components/SupplierPayments/CreateSupplierPayments";
import ViewSupplierInvoicesPayments from "./Components/SupplierPayments/ViewSupplierInvoicesPayments";
import RegisterUserPage from "./Components/users/RegisterUserPage";
import ViewUserPage from "./Components/users/ViewUserPage";
import UserProfile from "./Components/users/USerProfile";
import PermissionsDistribution from "./Components/users/PermissionsDistribution";
import UserPermissionsDistribution from "./Components/users/UserPermissionsDistribution";
import ViewRequisitionsWzRejectItems from "./Components/Requisition/ViewRequisitionsWzRejectItems";
import UserRoles from "./Components/users/UserRoles";
import RolePermissionsDistribution from "./Components/users/RolePermissionsDistribution";
import ViewRequisitionsToSetApprovalLevels from "./Components/Requisition/ViewRequisitionsToSetApprovalLevels";
import functions from "./util/functions";
import ActivateAccount from "./Pages/ActivateAccount";
import UpdateRequisition from "./Components/Requisition/UpdateRequisition";
import ViewSupplierInvoicesWzBalances from "./Components/SupplierIvoices/ViewSupplierInvoicesWzBalances";
import ViewSupplierInvoicesToSet4Payments from "./Components/SupplierIvoices/ViewSupplierInvoicesToSet4Payments";
import ConfirmSupplierPayments from "./Components/SupplierIvoices/ConfirmSupplierPayments";
import toast, { Toaster } from "react-hot-toast";
function App(props) {
  const [loggedIn, setLoggedIn] = useState(true);
  function checkLogin() {
    if (!window.localStorage.getItem("la_procure@user")) {
      setLoggedIn(false);
    } else {
      setLoggedIn(true);
    }
  }
  useEffect(() => {
    checkLogin();
  }, []);
  const logoutUser = () => {
    setLoggedIn(false);
    localStorage.removeItem("la_procure@user");
    window.location.reload();
  };
  useEffect(() => {
    let logoutTimer;
    // Function to start the logout timer for inactivity
    const startLogoutTimer = () => {
      logoutTimer = setTimeout(() => {
        logoutUser();
        toast.success("You have been logged out due to inactivity.");
      }, 1200000); // 20 minutes in milliseconds
    };
    // Function to reset the inactivity timer on user interaction
    const resetTimer = () => {
      clearTimeout(logoutTimer);
      startLogoutTimer();
    };
    startLogoutTimer();
    // Set up event listeners to reset the timer on user activity
    const activityEvents = ["mousemove", "keydown", "click"];
    activityEvents.forEach((event) =>
      window.addEventListener(event, resetTimer)
    );
    // Clean up event listeners and timer on component unmount
    return () => {
      activityEvents.forEach((event) =>
        window.removeEventListener(event, resetTimer)
      );
      clearTimeout(logoutTimer);
    };
  }, []);
  const secure = functions.checkSecureAccount();
  return (
    <SuperProvider>
      <Toaster />
      <Router forceRefresh={false}>
        <Switch>
          {!loggedIn && (
            <>
              <Route path="*" element={<LoginPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route
                path="/password_rest/forgot"
                element={<ForgotPassword />}
              />
              <Route
                path="/"
                element={
                  !loggedIn ? (
                    <Navigate replace to="/login" />
                  ) : (
                    <DashboardPage />
                  )
                }
              />
            </>
          )}
          {/* {loggedIn && secure * 1 === 0 && (
            <>
              <Route path="/Activate/account" element={<ActivateAccount />} />
              <Route path="/Activate/account" element={<ActivateAccount />} />
              <Route
                path="/"
                element={<Navigate replace to="/Activate/account" />}
              />
            </>
          )} */}
          {/* 
          {loggedIn && secure * 1 === 1 && ( */}
          {loggedIn && (
            <>
              <Route
                path="/"
                element={
                  !loggedIn ? (
                    <Navigate replace to="/login" />
                  ) : (
                    <DashboardPage />
                  )
                }
              />
              <Route
                path="/login"
                element={loggedIn ? <Navigate replace to="/" /> : <LoginPage />}
              />
              <Route path="/" element={<DashboardPage />} />
              <Route path="/Dashboard" element={<DashboardPage />} />
              <Route path="*" element={<ErrorPage />} />
              {/* departments */}
              <Route path="/departments" element={<DepartmentsPage />} />
              {/* suppliers */}
              <Route path="/suppliers" element={<SuppliersPage />} />
              {/* Requisitions */}
              <Route
                path="/requsition/create"
                element={<CreateRequisition />}
              />
              <Route
                path="/requisitions/View/rejectedItems"
                element={<ViewRequisitionsWzRejectItems />}
              />
              <Route path="/requisitions/View" element={<ViewRequisitions />} />
              <Route
                path="/requisition/update"
                element={<UpdateRequisition />}
              />
              <Route
                path="/requisitions/View/set_approval_levels"
                element={<ViewRequisitionsToSetApprovalLevels />}
              />
              {/* approvals */}
              <Route
                path="/approvals/pending"
                element={<PendingRequisitionApprovals />}
              />
              <Route
                path="/approvals/view_my_approvals"
                element={<UserRequisitionApprovals />}
              />
              {/* purchase Orders */}
              <Route
                path="/purchase_order/create"
                element={<CreatePurchaseOrder />}
              />
              <Route
                path="/purchase_orders/view_saved"
                element={<ViewPurchaseOrders />}
              />
              {/* Delivery Notes */}
              <Route
                path="/delievery_notes/create"
                element={<CreateDeliveryNote />}
              />
              <Route
                path="/delievery_notes/view"
                element={<ViewDeliveryNotes />}
              />
              {/* supplier Invoices*/}
              <Route
                path="/supplier_invoices/create"
                element={<CreateSupplierInvoice />}
              />
              <Route
                path="/supplier_invoices/view"
                element={<ViewSupplierInvoices />}
              />
              <Route
                path="/supplier_invoices/invoice_with_balances"
                element={<ViewSupplierInvoicesWzBalances />}
              />
              <Route
                path="/supplier_invoices/Set_Invoices_4_Payments"
                element={<ViewSupplierInvoicesToSet4Payments />}
              />
              <Route
                path="/supplier_invoices/confirm_supplier_payments"
                element={<ConfirmSupplierPayments />}
              />
              {/* supplier Invoices*/}
              <Route
                path="/supplier_payment/pay"
                element={<CreateSupplierPayments />}
              />
              <Route
                path="/supplier_payment/view"
                element={<ViewSupplierInvoicesPayments />}
              />
              {/* User managements*/}
              <Route
                path="/users/register_newbie"
                element={<RegisterUserPage />}
              />
              <Route path="/users/View_users" element={<ViewUserPage />} />
              <Route path="/user/profile" element={<UserProfile />} />
              <Route
                path="/users/permissions"
                element={<PermissionsDistribution />}
              />
              <Route
                path="/user/permissions/:userID"
                element={<UserPermissionsDistribution />}
              />
              <Route path="/users/roles" element={<UserRoles />} />
              <Route
                path="/users/roles/permissions/:role_id"
                element={<RolePermissionsDistribution />}
              />
            </>
          )}
        </Switch>
      </Router>
    </SuperProvider>
  );
}
export default App;
